<div style="display: flex; flex-direction: column">
  <div class="fake-ranking">
    <div *ngFor="let i of [1, 2]" style="flex: 1">
      <div class="fake-info" style="display: flex; flex-direction: column; gap: 10px">
        <opac-skeleton></opac-skeleton>
        <opac-skeleton></opac-skeleton>
        <opac-skeleton></opac-skeleton>
        <opac-skeleton></opac-skeleton>
        <opac-skeleton class="hide-tablet" style="width: 206px"></opac-skeleton>
      </div>

      <div class="fake-card">
        <ng-container *ngFor="let i of [1, 2]; let first = first">
          <div style="display: flex; padding: 30px 30px 105px; flex: 1; flex-direction: column">
            <opac-skeleton style="width: 120px; height: 14px; margin-bottom: 25px"></opac-skeleton>
            <div style="display: flex; gap: 8px; align-items: flex-end">
              <opac-skeleton style="width: 40px; height: 40px"></opac-skeleton>
              <opac-skeleton style="width: 31px; height: 14px"></opac-skeleton>
            </div>
          </div>

          <opac-skeleton class="separator" *ngIf="first"></opac-skeleton>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="fake-badges">
    <opac-skeleton class="fake-title"></opac-skeleton>

    <div style="display: flex; gap: 16px">
      <div class="fake-badge" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]">
        <opac-skeleton style="width: 90px; height: 90px; margin-bottom: 10px"></opac-skeleton>
        <opac-skeleton style="width: 112px; height: 14px; margin-bottom: 24px"></opac-skeleton>
        <opac-skeleton style="width: 112px; height: 14px; margin-bottom: 2px"></opac-skeleton>
        <opac-skeleton style="width: 60px; height: 12px"></opac-skeleton>
      </div>
    </div>
  </div>
</div>
